export type { Schema } from './amplify/data/resource';
export { outputs } from './amplify-outputs';
export { Header } from './amplify/core/utils/header';
